import React, { useState, useEffect } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { IoMdRadioButtonOff, IoMdRadioButtonOn, IoIosCheckmarkCircleOutline } from "react-icons/io";

export default function TextQuestion({ v, showAllAnswers, student_answer, onChange }) {

    const [answers, setanswers] = useState(""); 
    
    // function st_answers(k2) {
    //     if (student_answer) {
    //         return false;
    //     }
        
    //     let ck = v?.answers?.findIndex(r => r?.true == true);
    //     let right = false;
    //     if (ck == k2) {
    //         right = true;
    //     }
        
    //     setanswers(k2);
    //     if (typeof onChange !== 'undefined') onChange({ ID: v?.ID, answer: k2, right: right });
        
    // }

    function sendAnswer() {
        if (typeof onChange !== 'undefined') onChange({ ID: v?.ID, answer: answers, right: answers == v?.answers });
    }

    useEffect(() => {
        sendAnswer();
    }, [answers]);

    useEffect(() => {
        if (showAllAnswers) {
            
            setanswers(v?.answers);
        } else {
            if (student_answer) {
                setanswers(student_answer);
            } else {
                setanswers("");
            }
        }
    }, [showAllAnswers]);
    

    
    
    return (
        <div className='answersBox'>
            <textarea className='textAreaQuestion' value={answers} disabled={student_answer ? true : false} onChange={(e) => {setanswers(e.target.value);}}></textarea>
        </div>
    );
}